export const userProfilesWithPermissionText: {id:string,title:string,permissionText:string}[] = [
    { id: 'admin', title: 'Administrador', permissionText: 'permissão: total' },
    {
        id: 'corporate_quality_board',
        title: 'Diretoria da Qualidade Corporativa',
        permissionText: 'permissão: total'
    },
    {
        id: 'unit_general_manager',
        title: 'Diretor Geral da Unidade',
        permissionText: 'permissão: visualiza'
    },
    {
        id: 'location_manager',
        title: 'Gestor do Setor',
        permissionText: 'permissão: trata as notificações'
    },
    {
        id: 'corporate_quality_management',
        title: 'Gestão da Qualidade da Corporativa',
        permissionText: 'permissão: visualiza'
    },
    {
        id: 'nsp',
        title: 'NSP / Núcleo da Segurança do Paciente',
        permissionText: 'permissão: visualiza'
    },
    {
        id: 'location_qa',
        title: 'Qualidade da unidade',
        permissionText: 'permissão: trata as notificações'
    }
]
